import React from 'react';
import PropTypes from 'prop-types';
import MailIcon from '@narvar/nth-mail-icon';
import ConciergeIcon from '@narvar/nth-concierge-icon';
import PrinterlessIcon from '@narvar/nth-bit-icon-printerless';
import StoreIcon from '@narvar/nth-store-icon';
import Icon from '../Icon';
import {
  CONCIERGE_PARTNERSHIP,
  NARVAR_CONCIERGE,
  MAIL,
  PRINTERLESS_MAIL,
  STORE,
  BOXLESS,
  LOCAL_PICKUP,
  HAPPY_RETURNS,
  KEEP_THE_ITEM,
  HOME_PICKUP,
  LOCKER_DROPOFF,
  DROP_OFF,
  PICKUP,
} from '../../constants/returnMethods';

const OptionIcon = ({ optionKey, brandCTAColor }) => {
  const style = {
    width: '6rem',
    height: '6rem',
  };
  const iconProps = {
    fillColor: 'transparent',
    outlineColor: brandCTAColor,
    s: style,
  };
  switch (optionKey) {
    case MAIL:
    case KEEP_THE_ITEM:
      return <MailIcon {...iconProps} />;
    case STORE:
      return <StoreIcon {...iconProps} />;
    case DROP_OFF:
    case CONCIERGE_PARTNERSHIP:
      return <Icon.LoopPin {...iconProps} />;
    case BOXLESS:
    case NARVAR_CONCIERGE:
      return <ConciergeIcon {...iconProps} lineColor={brandCTAColor} />;
    case PRINTERLESS_MAIL:
      return <PrinterlessIcon {...iconProps} lineColor={brandCTAColor} />;
    case LOCAL_PICKUP:
    case HOME_PICKUP:
    case PICKUP:
      return <Icon.Truck {...iconProps} />;
    case HAPPY_RETURNS:
      return <Icon.HappyReturnsSquare {...iconProps} />;
    case LOCKER_DROPOFF:
      return <Icon.LockerWithArrow {...iconProps} />;
    default:
      return null;
  }
};

OptionIcon.propTypes = {
  optionKey: PropTypes.string.isRequired,
  brandCTAColor: PropTypes.string.isRequired,
};

export default OptionIcon;
